import React from "react";
import { Link } from "react-router-dom";
import Layout from "../layout/Layout";
import { Panel } from "../components/ui";

export default function NotFound() {
  return (
    <Layout>
      <div className="lucid-container" style={{ padding: "60px 16px" }}>
        <Panel style={{ maxWidth: 560, margin: "0 auto", textAlign: "center" }}>
          <div style={{ fontSize: 66, fontWeight: 900, color: "var(--lt-purple-600)" }}>404</div>
          <h2 className="lt-panel__title">ไม่พบหน้าที่คุณต้องการ</h2>
          <p className="lt-helper lt-mb-24">หน้าที่คุณเปิดอาจถูกย้ายหรือลบไปแล้ว</p>
          <Link to="/" className="lt-btn lt-btn--primary">
            กลับหน้าหลัก
          </Link>
        </Panel>
      </div>
    </Layout>
  );
}
